import{addToCartTypes} from '../constants';
export const addScenarioToCart = (data) =>{
  console.log("in action",data)
  return {
    type:addToCartTypes().addItems,
    count : data.count,
    items : data.items,
  }
}

export const addGroupToCart = (obj) =>{
  return{
    type :addToCartTypes().addGroup,
    group : obj.group,
  }
}


export const updateShoppingCart = (obj) =>{
  return{
    type : addToCartTypes().updateCart,
    count : obj.count,
    items : obj.items,
  }
}

